export default "__VITE_ASSET__$CH9qXAV__"